import React, { useRef } from 'react';
var VeltNotificationsPanelContentListItemBody = function (props) {
    var notification = props.notification, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-list-item-body", { ref: ref, notification: notification ? (typeof notification === "string" ? notification : JSON.stringify(notification)) : undefined }, children));
};
export default VeltNotificationsPanelContentListItemBody;
